/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AirlineResult
 */
export interface AirlineResult {
    /**
     * 
     * @type {string}
     * @memberof AirlineResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AirlineResult
     */
    iataCode: string;
}

/**
 * Check if a given object implements the AirlineResult interface.
 */
export function instanceOfAirlineResult(value: object): value is AirlineResult {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('iataCode' in value) || value['iataCode'] === undefined) return false;
    return true;
}

export function AirlineResultFromJSON(json: any): AirlineResult {
    return AirlineResultFromJSONTyped(json, false);
}

export function AirlineResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AirlineResult {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'iataCode': json['iata_code'],
    };
}

export function AirlineResultToJSON(json: any): AirlineResult {
    return AirlineResultToJSONTyped(json, false);
}

export function AirlineResultToJSONTyped(value?: AirlineResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'iata_code': value['iataCode'],
    };
}

